module.exports = __webpack_public_path__ + "img/background.1e9bbf88.png";